import { adminApiClient } from './adminApiClient';
import type {
  AdminLoginRequest,
  AdminLoginResponse,
  AdminMeResponse,
} from '../auth/types';

export const adminAuthService = {
  async login(credentials: AdminLoginRequest): Promise<AdminLoginResponse> {
    const response = await adminApiClient.post<AdminLoginResponse>(
      '/admin/auth/login',
      credentials,
    );
    return response.data;
  },

  async logout(): Promise<void> {
    await adminApiClient.post('/admin/auth/logout');
  },

  async me(): Promise<AdminMeResponse> {
    const response =
      await adminApiClient.get<AdminMeResponse>('/admin/auth/me');
    return response.data;
  },
};
